// extracted by mini-css-extract-plugin
export default {"basketCard":"basketCard__35uqX"};
    if(module.hot) {
      // 1788784369788
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  